import { Icon } from "@shared/components";
import { useBonuses } from "@shared/hooks/bonuses";
import { useLobbyParams } from "@shared/hooks/lobby/lobby";
import { useUser } from "@shared/hooks/user";
import { determinateCurrency } from "@shared/utils/sweepstakes";
import React, { memo } from "react";
import { FormattedMessage, useIntl } from "react-intl";

interface IProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  bonus?: {
    amount: string;
    type: string;
  };
  isShort?: boolean;
}

export const BonusButton: React.FC<IProps> = memo(
  ({ onClick, bonus, isShort = false }) => {
    const user = useUser();
    const { bonus: localBonus } = useBonuses() ?? bonus;
    const { sweepstakes: isSweepstakesEnabled } = useLobbyParams() ?? {};
    const amount = +localBonus?.amount / 100 ?? 0;
    const intl = useIntl();

    return (
      <button className="take-bonus" onClick={onClick}>
        <Icon className="take-bonus__image" name="present" size={42} />
        {isShort ? (
          <FormattedMessage id="boilerplate.components.Header.TakeBonus" />
        ) : (
          <>
            <div className="flex-center take-bonus__gap">
              {intl.formatMessage({
                id: "boilerplate.components.Header.TakeBonus",
              })}
              <span>{bonus?.type}</span>
              <span>{amount}</span>
              <span>
                {determinateCurrency(isSweepstakesEnabled, user.currency)}
              </span>
            </div>
          </>
        )}
      </button>
    );
  }
);

BonusButton.displayName = "BonusButton";
